import * as distance from '~/constants/distance';

export type JSONCarrierParcelTemplate = {
  distance_unit: string;
  height: string;
  is_variable_dimensions: boolean;
  length: string;
  name: string;
  provider: string;
  token: string;
  width: string;
};

type CarrierParcelTemplate = {
  distanceUnit: distance.DistanceUnit;
  height: number;
  isVariableDimensions: boolean;
  length: number;
  name: string;
  provider: string;
  token: string;
  width: number;
};

export type WebCarrierParcelTemplate = {
  api_token: string;
  carrier: string;
  distance_unit: distance.DistanceUnit;
  height: string;
  is_variable_dimensions: boolean;
  length: string;
  name: string;
  token: string;
  width: string;
};

const unitValue: CarrierParcelTemplate = {
  distanceUnit: distance.DistanceUnit.IN,
  height: 0,
  isVariableDimensions: false,
  length: 0,
  name: '',
  provider: '',
  token: '',
  width: 0,
};

export const fromJSON = (
  jsonCarrierParcelTemplate: Maybe<JSONCarrierParcelTemplate>,
): Maybe<CarrierParcelTemplate> => {
  if (!jsonCarrierParcelTemplate) return null;

  return {
    distanceUnit: distance.distanceUnitMap[jsonCarrierParcelTemplate.distance_unit],
    height: Number(jsonCarrierParcelTemplate.height),
    isVariableDimensions: jsonCarrierParcelTemplate.is_variable_dimensions,
    length: Number(jsonCarrierParcelTemplate.length),
    name: jsonCarrierParcelTemplate.name,
    provider: jsonCarrierParcelTemplate.provider,
    token: jsonCarrierParcelTemplate.token,
    width: Number(jsonCarrierParcelTemplate.width),
  };
};

export const toJSON = (
  carrierParcelTemplate: CarrierParcelTemplate,
): JSONCarrierParcelTemplate => ({
  distance_unit: carrierParcelTemplate.distanceUnit,
  height: carrierParcelTemplate.height.toString(),
  is_variable_dimensions: carrierParcelTemplate.isVariableDimensions,
  length: carrierParcelTemplate.length.toString(),
  name: carrierParcelTemplate.name,
  provider: carrierParcelTemplate.provider,
  token: carrierParcelTemplate.token,
  width: carrierParcelTemplate.width.toString(),
});

export const fromWebCarrierParcelTemplate = (
  template?: WebCarrierParcelTemplate,
): CarrierParcelTemplate => {
  if (!template) return unitValue;

  return {
    distanceUnit: template.distance_unit,
    height: Number(template.height),
    isVariableDimensions: template.is_variable_dimensions,
    length: Number(template.length),
    name: template.name,
    provider: template.carrier,
    token: template.token,
    width: Number(template.width),
  };
};

export default CarrierParcelTemplate;
